export default __webpack_public_path__ + "static/media/404_2 (1).70105cf7.png";